import { collection, query, getDocs } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export async function fetchAllExamResults(uid) {
  const resultsRef = collection(db, 'artifacts', appId, 'users', uid, 'exam_results');
  const snap = await getDocs(query(resultsRef));
  const rows = [];
  snap.forEach((doc) => {
    rows.push(doc.data());
  });
  return rows;
}
